import { map, observeOn } from 'rxjs/operators'
import { asapScheduler, asyncScheduler } from 'rxjs'

export function isEmptyTable(source: any, immediate = false) {
  return source['_renderData'].pipe(
    map((rows: any) => (rows || []).length === 0),
    observeOn(immediate ? asapScheduler : asyncScheduler)
  )
}
